// Module-level registry decoupling the offline-toast producer (useLocalMutation's
// commit path) from the consumer (ToastProvider's showInfo). Kept in its own
// module so useToast.jsx never imports useLocalMutation.js — wholesale mocks of
// useLocalMutation in page tests stay valid, and the coalescer state stays
// shared across every hook instance.
// Reason: ArticlesProvider (a useLocalMutation caller) mounts above ToastProvider,
// so useLocalMutation can't pull the toast via useToast() without throwing.

let offlineToastNotifier = null;

// Pass `expected` to unregister only when the current notifier still matches it
// (compare-before-clear), so a later provider's registration isn't clobbered.
export function registerOfflineToastNotifier(fn, expected) {
  if (fn === null && expected !== undefined && offlineToastNotifier !== expected) return;
  offlineToastNotifier = fn;
}

export function getOfflineToastNotifier() {
  return offlineToastNotifier;
}
